import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useProjectStoryById} from '../../../../entities';

interface DeleteProjectStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  storyId: string;
}

export const DeleteProjectStoryModal = ({open, setOpen, storyId}: DeleteProjectStoryModalProps) => {
  const {deleteProjectStoryMutation} = useProjectStoryById(storyId);

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Новость проекта',
    title: 'Ошибка при удалении новости проекта',
  });

  useEffect(() => {
    if (deleteProjectStoryMutation.error) {
      handleError(deleteProjectStoryMutation.error as unknown as ApiError);
    }
  }, [deleteProjectStoryMutation.error, handleError]);

  const handleDeleteStory = async () => {
    try {
      await deleteProjectStoryMutation.mutateAsync(storyId);
      setOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleDeleteStory}
        isLoading={deleteProjectStoryMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление новости проекта'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить эту новость проекта? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
